import React from "react";

/** Readable-register label for form fields (Inter, 13px medium). */
export default function FormLabel({ children, className = "", as: Tag = "span", ...rest }) {
  return (
    <Tag className={`font-ui text-[13px] font-medium text-ink ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
